/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

import { Route as rootRouteImport } from './routes/__root'
import { Route as LoginLinkModalRouteImport } from './routes/login-link-modal'

const LoginLinkLazyRouteImport = createFileRoute('/login-link')()
const LoginLazyRouteImport = createFileRoute('/login')()
const LibraryLazyRouteImport = createFileRoute('/library')()
const CatalogLazyRouteImport = createFileRoute('/catalog')()
const IndexLazyRouteImport = createFileRoute('/')()
const ReadBookIdLazyRouteImport = createFileRoute('/read/$bookId')()
const BookBookIdLazyRouteImport = createFileRoute('/book/$bookId')()
const ReadBookIdVisualsLazyRouteImport = createFileRoute(
  '/read/$bookId/visuals',
)()
const ReadBookIdContentLazyRouteImport = createFileRoute(
  '/read/$bookId/content',
)()
const ReadBookIdCombinedLazyRouteImport = createFileRoute(
  '/read/$bookId/combined',
)()
const BookBookIdImageLazyRouteImport = createFileRoute('/book/$bookId/image')()

const LoginLinkLazyRoute = LoginLinkLazyRouteImport.update({
  id: '/login-link',
  path: '/login-link',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/login-link.lazy').then((d) => d.Route))
const LoginLazyRoute = LoginLazyRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/login.lazy').then((d) => d.Route))
const LibraryLazyRoute = LibraryLazyRouteImport.update({
  id: '/library',
  path: '/library',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/library.lazy').then((d) => d.Route))
const CatalogLazyRoute = CatalogLazyRouteImport.update({
  id: '/catalog',
  path: '/catalog',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/catalog.lazy').then((d) => d.Route))
const LoginLinkModalRoute = LoginLinkModalRouteImport.update({
  id: '/login-link-modal',
  path: '/login-link-modal',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexLazyRoute = IndexLazyRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/index.lazy').then((d) => d.Route))
const ReadBookIdLazyRoute = ReadBookIdLazyRouteImport.update({
  id: '/read/$bookId',
  path: '/read/$bookId',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/read.$bookId.lazy').then((d) => d.Route))
const BookBookIdLazyRoute = BookBookIdLazyRouteImport.update({
  id: '/book/$bookId',
  path: '/book/$bookId',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/book.$bookId.lazy').then((d) => d.Route))
const ReadBookIdVisualsLazyRoute = ReadBookIdVisualsLazyRouteImport.update({
  id: '/visuals',
  path: '/visuals',
  getParentRoute: () => ReadBookIdLazyRoute,
} as any).lazy(() =>
  import('./routes/read.$bookId.visuals.lazy').then((d) => d.Route),
)
const ReadBookIdContentLazyRoute = ReadBookIdContentLazyRouteImport.update({
  id: '/content',
  path: '/content',
  getParentRoute: () => ReadBookIdLazyRoute,
} as any).lazy(() =>
  import('./routes/read.$bookId.content.lazy').then((d) => d.Route),
)
const ReadBookIdCombinedLazyRoute = ReadBookIdCombinedLazyRouteImport.update({
  id: '/combined',
  path: '/combined',
  getParentRoute: () => ReadBookIdLazyRoute,
} as any).lazy(() =>
  import('./routes/read.$bookId.combined.lazy').then((d) => d.Route),
)
const BookBookIdImageLazyRoute = BookBookIdImageLazyRouteImport.update({
  id: '/image',
  path: '/image',
  getParentRoute: () => BookBookIdLazyRoute,
} as any).lazy(() =>
  import('./routes/book.$bookId.image.lazy').then((d) => d.Route),
)

export interface FileRoutesByFullPath {
  '/': typeof IndexLazyRoute
  '/login-link-modal': typeof LoginLinkModalRoute
  '/catalog': typeof CatalogLazyRoute
  '/library': typeof LibraryLazyRoute
  '/login': typeof LoginLazyRoute
  '/login-link': typeof LoginLinkLazyRoute
  '/book/$bookId': typeof BookBookIdLazyRouteWithChildren
  '/read/$bookId': typeof ReadBookIdLazyRouteWithChildren
  '/book/$bookId/image': typeof BookBookIdImageLazyRoute
  '/read/$bookId/combined': typeof ReadBookIdCombinedLazyRoute
  '/read/$bookId/content': typeof ReadBookIdContentLazyRoute
  '/read/$bookId/visuals': typeof ReadBookIdVisualsLazyRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexLazyRoute
  '/login-link-modal': typeof LoginLinkModalRoute
  '/catalog': typeof CatalogLazyRoute
  '/library': typeof LibraryLazyRoute
  '/login': typeof LoginLazyRoute
  '/login-link': typeof LoginLinkLazyRoute
  '/book/$bookId': typeof BookBookIdLazyRouteWithChildren
  '/read/$bookId': typeof ReadBookIdLazyRouteWithChildren
  '/book/$bookId/image': typeof BookBookIdImageLazyRoute
  '/read/$bookId/combined': typeof ReadBookIdCombinedLazyRoute
  '/read/$bookId/content': typeof ReadBookIdContentLazyRoute
  '/read/$bookId/visuals': typeof ReadBookIdVisualsLazyRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexLazyRoute
  '/login-link-modal': typeof LoginLinkModalRoute
  '/catalog': typeof CatalogLazyRoute
  '/library': typeof LibraryLazyRoute
  '/login': typeof LoginLazyRoute
  '/login-link': typeof LoginLinkLazyRoute
  '/book/$bookId': typeof BookBookIdLazyRouteWithChildren
  '/read/$bookId': typeof ReadBookIdLazyRouteWithChildren
  '/book/$bookId/image': typeof BookBookIdImageLazyRoute
  '/read/$bookId/combined': typeof ReadBookIdCombinedLazyRoute
  '/read/$bookId/content': typeof ReadBookIdContentLazyRoute
  '/read/$bookId/visuals': typeof ReadBookIdVisualsLazyRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login-link-modal'
    | '/catalog'
    | '/library'
    | '/login'
    | '/login-link'
    | '/book/$bookId'
    | '/read/$bookId'
    | '/book/$bookId/image'
    | '/read/$bookId/combined'
    | '/read/$bookId/content'
    | '/read/$bookId/visuals'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login-link-modal'
    | '/catalog'
    | '/library'
    | '/login'
    | '/login-link'
    | '/book/$bookId'
    | '/read/$bookId'
    | '/book/$bookId/image'
    | '/read/$bookId/combined'
    | '/read/$bookId/content'
    | '/read/$bookId/visuals'
  id:
    | '__root__'
    | '/'
    | '/login-link-modal'
    | '/catalog'
    | '/library'
    | '/login'
    | '/login-link'
    | '/book/$bookId'
    | '/read/$bookId'
    | '/book/$bookId/image'
    | '/read/$bookId/combined'
    | '/read/$bookId/content'
    | '/read/$bookId/visuals'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexLazyRoute: typeof IndexLazyRoute
  LoginLinkModalRoute: typeof LoginLinkModalRoute
  CatalogLazyRoute: typeof CatalogLazyRoute
  LibraryLazyRoute: typeof LibraryLazyRoute
  LoginLazyRoute: typeof LoginLazyRoute
  LoginLinkLazyRoute: typeof LoginLinkLazyRoute
  BookBookIdLazyRoute: typeof BookBookIdLazyRouteWithChildren
  ReadBookIdLazyRoute: typeof ReadBookIdLazyRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/login-link': {
      id: '/login-link'
      path: '/login-link'
      fullPath: '/login-link'
      preLoaderRoute: typeof LoginLinkLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/library': {
      id: '/library'
      path: '/library'
      fullPath: '/library'
      preLoaderRoute: typeof LibraryLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/catalog': {
      id: '/catalog'
      path: '/catalog'
      fullPath: '/catalog'
      preLoaderRoute: typeof CatalogLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login-link-modal': {
      id: '/login-link-modal'
      path: '/login-link-modal'
      fullPath: '/login-link-modal'
      preLoaderRoute: typeof LoginLinkModalRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/read/$bookId': {
      id: '/read/$bookId'
      path: '/read/$bookId'
      fullPath: '/read/$bookId'
      preLoaderRoute: typeof ReadBookIdLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/book/$bookId': {
      id: '/book/$bookId'
      path: '/book/$bookId'
      fullPath: '/book/$bookId'
      preLoaderRoute: typeof BookBookIdLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/read/$bookId/visuals': {
      id: '/read/$bookId/visuals'
      path: '/visuals'
      fullPath: '/read/$bookId/visuals'
      preLoaderRoute: typeof ReadBookIdVisualsLazyRouteImport
      parentRoute: typeof ReadBookIdLazyRoute
    }
    '/read/$bookId/content': {
      id: '/read/$bookId/content'
      path: '/content'
      fullPath: '/read/$bookId/content'
      preLoaderRoute: typeof ReadBookIdContentLazyRouteImport
      parentRoute: typeof ReadBookIdLazyRoute
    }
    '/read/$bookId/combined': {
      id: '/read/$bookId/combined'
      path: '/combined'
      fullPath: '/read/$bookId/combined'
      preLoaderRoute: typeof ReadBookIdCombinedLazyRouteImport
      parentRoute: typeof ReadBookIdLazyRoute
    }
    '/book/$bookId/image': {
      id: '/book/$bookId/image'
      path: '/image'
      fullPath: '/book/$bookId/image'
      preLoaderRoute: typeof BookBookIdImageLazyRouteImport
      parentRoute: typeof BookBookIdLazyRoute
    }
  }
}

interface BookBookIdLazyRouteChildren {
  BookBookIdImageLazyRoute: typeof BookBookIdImageLazyRoute
}

const BookBookIdLazyRouteChildren: BookBookIdLazyRouteChildren = {
  BookBookIdImageLazyRoute: BookBookIdImageLazyRoute,
}

const BookBookIdLazyRouteWithChildren = BookBookIdLazyRoute._addFileChildren(
  BookBookIdLazyRouteChildren,
)

interface ReadBookIdLazyRouteChildren {
  ReadBookIdCombinedLazyRoute: typeof ReadBookIdCombinedLazyRoute
  ReadBookIdContentLazyRoute: typeof ReadBookIdContentLazyRoute
  ReadBookIdVisualsLazyRoute: typeof ReadBookIdVisualsLazyRoute
}

const ReadBookIdLazyRouteChildren: ReadBookIdLazyRouteChildren = {
  ReadBookIdCombinedLazyRoute: ReadBookIdCombinedLazyRoute,
  ReadBookIdContentLazyRoute: ReadBookIdContentLazyRoute,
  ReadBookIdVisualsLazyRoute: ReadBookIdVisualsLazyRoute,
}

const ReadBookIdLazyRouteWithChildren = ReadBookIdLazyRoute._addFileChildren(
  ReadBookIdLazyRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexLazyRoute: IndexLazyRoute,
  LoginLinkModalRoute: LoginLinkModalRoute,
  CatalogLazyRoute: CatalogLazyRoute,
  LibraryLazyRoute: LibraryLazyRoute,
  LoginLazyRoute: LoginLazyRoute,
  LoginLinkLazyRoute: LoginLinkLazyRoute,
  BookBookIdLazyRoute: BookBookIdLazyRouteWithChildren,
  ReadBookIdLazyRoute: ReadBookIdLazyRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
